<template>
  <section>
    <p class="title is-1">Realizar abono</p>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item tag='router-link'
        :to="{ name: 'AbonosComponent', params: { id: this.$route.params.id } }">Abonos</b-breadcrumb-item>
      <b-breadcrumb-item active>Realizar abono</b-breadcrumb-item>
    </b-breadcrumb>
    <p class="is-size-5 has-text-weight-semibold">
      Deuda total: ${{ formatoMonto(porPagar) }}
    </p>
    <hr class="my-2">
    <b-switch class="mb-3" v-model="liquidar" @input="fijarMonto">
      Liquidar deuda total
    </b-switch>
    <form @submit.prevent="onRegistrar">
      <b-field label="Monto a abonar">
        <b-input type="number" step="0.01" v-model="monto" placeholder="Introduce el monto a abonar..."
          icon="currency-usd" :max="porPagar" :readonly="liquidar" required></b-input>
      </b-field>
      <b-field label="Método de pago">
        <b-select class="wide" placeholder="Seleccionar..." icon="tag-multiple" v-model="idMetodo" required>
          <option v-for="metodo in metodosSimples" :key="metodo" :value="metodo">
            {{ metodo }}
          </option>
          <option v-for="metodo in metodos" :key="metodo.id" :value="metodo.id">
            {{ metodo.nombre }}
          </option>
        </b-select>
      </b-field>
      <b-field label="Origen" v-if="!esSimple && idMetodo">
        <b-input type="text" name="origen" v-model="origen" placeholder="Origen del pago" icon="account"
          required></b-input>
      </b-field>
      <b-field class="mt-3" label="Esta factura se genera en">
        <b-select class="wide" placeholder="Seleccionar..." icon="receipt" v-model="moneda" required
          @input="manejarMoneda">
          <option key="usd" value="usd">Dólares</option>
          <option key="bs" value="bs">Bolívares</option>
        </b-select>
      </b-field>
      <hr class="mb-2 mt-4">
      <p class="is-size-5 has-text-weight-semibold">
        Restante después del abono: ${{ formatoMonto(restante) }}
      </p>
      <div class="buttons has-text-centered mt-5">
        <b-button native-type="submit" type="is-primary" icon-left="check">Registrar</b-button>
        <b-button type="is-dark" icon-left="cancel" tag="router-link"
          :to="{ name: 'AbonosComponent', params: { id: this.$route.params.id } }">Cancelar</b-button>
      </div>
    </form>
    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
  </section>
</template>
<script>
import { TIPOS_PAGO_SIMPLE } from '@/consts'
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'

export default {
  name: 'RealizarAbono',

  data: () => ({
    moneda: 'usd',
    cargando: false,
    metodos: [],
    porPagar: null,
    origen: null,
    simple: null,
    monto: null,
    idMetodo: null,
    metodosSimples: Object.values(TIPOS_PAGO_SIMPLE),
    liquidar: false,
  }),

  mounted ()
  {
    this.obtenerDatos()
  },

  methods: {
    fijarMonto ()
    {
      if (this.liquidar) {
        this.monto = this.porPagar.toFixed(2)
      } else {
        this.monto = null
      }
    },

    formatoMonto (valor)
    {
      return Utiles.formatoMonto(valor)
    },

    manejarMoneda ()
    {
      this.$emit('actualizar', 'moneda', this.moneda)
    },

    async obtenerDatos ()
    {
      this.cargando = true

      const porPagarPromise = HttpService.obtenerConConsultas('ventas.php', {
        accion: 'por_pagar',
        id: this.$route.params.id,
      })

      const metodosPromise = HttpService.obtenerConConsultas('metodos.php', {
        accion: 'obtener'
      })

      const [porPagar, metodos] = await Promise.all([
        porPagarPromise, metodosPromise
      ])

      this.porPagar = Number(porPagar)
      this.metodos = metodos
      this.cargando = false
    },

    async onRegistrar ()
    {
      this.cargando = true
      let tasa = null

      if (this.moneda === 'bs') {
        const resultado = await HttpService.registrar('ventas.php', {
          accion: 'obtener_tasa'
        })

        tasa = resultado.id
      }

      const payload = {
        accion: 'realizar_abono',
        abono: {
          monto: this.monto,
          idCuenta: this.$route.params.id,
          idTasa: tasa
        },
      }

      if (this.esSimple) {
        payload.abono.simple = this.idMetodo
      } else {
        payload.abono.idMetodo = this.idMetodo
        payload.abono.origen = this.origen
      }

      const registrado = await HttpService.registrar('ventas.php', payload)
      // TODO -> imprimir comprobante de abono
      this.cargando = false
      if (!registrado) return

      this.$router.push({
        name: 'AbonosComponent',
        params: { id: this.$route.params.id }
      })

      this.$buefy.toast.open({
        type: 'is-info',
        message: 'Abono registrado con éxito.'
      })
    },
  },

  computed: {
    esSimple ()
    {
      return this.metodosSimples.includes(this.idMetodo)
    },
    restante ()
    {
      return this.porPagar - Number(this.monto)
    }
  }
}
</script>

<style>
input[readonly].input {
  background-color: whitesmoke;
  cursor: default;
  pointer-events: none;
  user-select: none;
}
</style>
